import { Link } from "react-router-dom";
const DesktopRegisterForm = ({
	register,
	errors,
	handleSubmit,
	onSubmit,
	showPassword,
	setShowPassword,
}) => {
	return (
		<form
			onSubmit={handleSubmit(onSubmit)}
			className="flex flex-col gap-[16px]"
		>
			<input
				type="text"
				placeholder="Full Name"
				{...register("name")}
				className="w-[321px] h-[33px] rounded-[8px] border border-[#193D34] p-[8px] outline-none"
			/>
			{errors.name && (
				<p className="text-red-500 text-sm mt-1">{errors.name.message}</p>
			)}

			<input
				type="text"
				placeholder="Email"
				{...register("email")}
				className="w-[321px] h-[33px] rounded-[8px] border border-[#193D34] p-[8px] outline-none"
			/>
			{errors.email && (
				<p className="text-red-500 text-sm mt-1">{errors.email.message}</p>
			)}

			<div className="relative">
				<input
					type={showPassword ? "text" : "password"}
					{...register("password")}
					placeholder="Password"
					className="w-[321px] h-[36px] rounded-[8px] border border-[#193D34] pr-[40px] pl-[8px] outline-none"
				/>
				<img
					src="/assets/login/eye-off.svg"
					alt="toggle visibility"
					onClick={(e) => {
						e.preventDefault();
						setShowPassword(!showPassword);
					}}
					className="absolute right-[8px] top-1/2 transform -translate-y-1/2 w-[20px] h-[20px] cursor-pointer"
				/>
			</div>
			{errors.password && (
				<p className="text-red-500 text-sm mt-1">{errors.password.message}</p>
			)}

			<div className="flex items-center gap-2">
				<input
					type="checkbox"
					{...register("terms")}
					className="appearance-none w-6 h-6 rounded-full border-2 border-gray-300 
          checked:bg-[#B7D974] cursor-pointer transition-colors
          focus:outline-none focus:ring-2 focus:ring-[#B7D974]"
				/>
				<label className="text-xs font-montserrat">
					I agree with Terms of Use and Privacy Policy
				</label>
			</div>
			{errors.terms && (
				<p className="text-red-500 text-sm mt-1">{errors.terms.message}</p>
			)}

			<div className="w-[135px] h-[82px] flex flex-col items-center justify-center mx-auto gap-[16px]">
				<Link to="/forgot-password">
					<div className="w-[135px] h-[34px] rounded-[24px] p-[8px] flex items-center justify-center cursor-pointer text-[12px] text-[#193D34] font-montserrat">
						Forgot Password?
					</div>
				</Link>
				<button
					type="submit"
					className="w-[112px] h-[32px] flex items-center justify-center rounded-[24px] p-[8px] bg-[#B7D974] text-[#193D34] text-[13px] font-[500] font-montserrat leading-[24px] text-center"
				>
					Sign UP
				</button>
			</div>
		</form>
	);
};

export default DesktopRegisterForm;
